export default {
    task: null,
    answer: null,
    tasks: null,
};
